import { useState } from "react";
import { Link } from "react-router-dom";
import { downloadEbookFile } from "../../api/ebookApi";

export default function EbookDownloadButton({
  ebook,
  userId,
  size = "md",
  className = "",
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const padding =
    size === "sm" ? "px-4 py-2 text-sm" : "px-5 py-2.5 text-sm";

  const handleDownload = async () => {
    if (!userId) return;
    setLoading(true);
    setError("");
    try {
      await downloadEbookFile(ebook.id, userId, ebook.file_name || `${ebook.title}.file`);
    } catch (err) {
      setError(err.message || "下载失败");
    } finally {
      setLoading(false);
    }
  };

  if (!userId) {
    return (
      <div className={`space-y-2 ${className}`}>
        <div className="inline-flex items-center gap-2 rounded-full bg-amber-50 border border-amber-100 px-4 py-2 text-sm text-amber-700">
          <span>🔒</span>
          <span>注册会员即可免费下载</span>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link
            to="/register"
            className={`${padding} rounded-full bg-pink-500 text-white hover:bg-pink-600`}
          >
            立即注册
          </Link>
          <Link
            to="/login"
            className={`${padding} rounded-full border border-pink-300 text-pink-600 hover:bg-pink-50`}
          >
            立即登录
          </Link>
        </div>
      </div>
    );
  }

  if (!ebook?.can_download) {
    return (
      <p className={`text-sm text-gray-500 ${className}`}>
        当前无法下载此书，可能已下架或权限不足。
      </p>
    );
  }

  return (
    <div className={`space-y-2 ${className}`}>
      <button
        type="button"
        onClick={handleDownload}
        disabled={loading}
        className={`${padding} rounded-full bg-emerald-500 text-white hover:bg-emerald-600 disabled:opacity-60`}
      >
        {loading ? "下载中..." : "⬇ 免费下载"}
      </button>
      {error ? <p className="text-sm text-red-500">{error}</p> : null}
    </div>
  );
}
